import Vue from 'vue';
import App from './App.vue';
import router from './router';
import _ from 'lodash';
import moment from 'moment';

//API Handler
import api from './services/api';
import tempApi from './services/tempApi';

//VueJs UI Framework
import vuetify from './plugins/vuetify';
import './plugins/elementui';

//External Components
import Toolbar from './components/Toolbar'
import ContentLayout from './components/ContentLayout.vue';
import ExportTable from './components/ExportTable';
import VueExcelXlsx from "vue-excel-xlsx";
import ETable from './components/ETable';
import ExportToExcel from './components/ExportToExcel.vue';

//External Plugins
import './plugins/progressbar';
import './plugins/toast';
import './plugins/tooltip';
import store from './store';
import onresize from './services/onresize';
import downloadFile from './services/downloadFileSvc';
import Clipboard from 'v-clipboard'


Vue.config.productionTip = false;

//Initialize Components/Plugins/Api
Vue.prototype.$downloadFile = downloadFile
Vue.prototype.$_ = _;
Vue.prototype.$moment = moment;
Vue.use(Clipboard)
Vue.use(VueExcelXlsx)
Vue.prototype.$http = api;
Vue.prototype.$http2 = tempApi;
const user = localStorage.getItem('user')
if (user) {
  Vue.prototype.$http2.defaults.headers.common['x-auth-token'] = JSON.parse(user).token
}
Vue.component('my-toolbar', Toolbar);
Vue.component('v-content-layout', ContentLayout);
Vue.component('v-export-table', ExportTable);
Vue.component('e-table', ETable);
Vue.component('export-to-excel', ExportToExcel)

Vue.mixin(onresize);

export const bus = new Vue();
export default new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app');
